
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { Lead, StepNames, Task } from '@/types';

@Component
export default class TaskDetailsTitleCircle extends Vue {
  @Prop(Object) readonly task: Task | undefined;
  @Prop(String) readonly step: StepNames | undefined;
  @Prop({ type: Boolean, default: false }) readonly ecobonusCheck!: boolean;

  get selectedLead(): Lead | null {
    return this.$store.getters.currentLead;
  }

  get selectedTask(): Task | null {
    // Se non è stato specificato un Task nelle Prop,
    // utilizza il Task selezionato memorizzato tramite Vuex.
    return this.task ?? this.$store.getters.selectedTask;
  }

  get loading(): boolean {
    // Se è stato specificato un Task nelle Prop,
    // non utilizza questo boolean (sempre false).
    return this.task
      ? false
      : this.$store.getters.isTaskLoading;
  }

  get updating(): boolean {
    // Se è stato specificato un Task nelle Prop,
    // non utilizza questo boolean (sempre false).
    return this.task
      ? false
      : this.$store.getters.isTaskUpdating;
  }

  get stepName(): string | null {
    if (!this.step) return null;

    switch (this.step) {
      case 'step1':
        return 'C';
      case 'step2':
        return 'S';
      case 'step3':
        return 'P';
      case 'step4':
        return 'A';
      default:
        return null;
    }
  }

  get name() {
    if (this.ecobonusCheck) return 'F';
    if (this.selectedTask) return this.selectedTask.name;
    if (this.step) return this.stepName;
    return null;
  }

  get currentLeadStatus() {
    return this.isCurrentProject
      ? this.selectedLead?.status
      : this.leadInfo?.status;
  }

  get isCurrentProject(): boolean {
    return Boolean(
      this.selectedLead && this.task && this.selectedLead.id === (this.task.childLeadId ?? this.task.LeadId),
    );
  }

  get leadInfo(): Lead | null {
    if (this.leadId
      && this.leadId in this.childLeads) return this.childLeads[this.leadId];

    if (this.leadId && this.selectedLead
      && this.selectedLead.id === this.leadId) return this.selectedLead;

    return null;
  }

  get leadId(): number | null {
    if (this.task?.childLeadId && this.task.childLeadId) return this.task.childLeadId;

    // if (this.selectedLead && this.selectedLead.id) return this.selectedLead.id;

    return this.task?.LeadId || null;
  }

  get childLeads() {
    // return this.$store.getters.currentChildren;
    return this.$store.getters.currentChildrenInfo;
  }

  get color() {
    if (this.loading) return 'grey lighten-2';

    if (this.currentLeadStatus === 'resolved' && !this.task?.status) {
      return 'light-green soft';
    }

    if (this.ecobonusCheck) {
      return this.isEcobonusCheckDone
        ? this.ecobonusCheckResult.range.color.trim()
        : 'grey lighten-2';
    }

    if (this.selectedTask) {
      if (!this.selectedTask.status) {
        return 'grey lighten-2';
      }
      if (this.selectedTask.status === 'disabled') {
        return 'grey darken-2';
      }
      if (this.selectedTask.status === 'completed') {
        return this.selectedTask.extraCosti ? 'yellow darken-1' : 'light-green';
      }
      if (this.selectedTask.status === 'error') {
        return 'error';
      }
      return 'grey lighten-2';
    }

    if (this.step && this.selectedLead && this.step in this.selectedLead) {
      switch (this.selectedLead[this.step]) {
        case true:
          return 'light-green';
        case false:
          return 'red';
        default:
          return 'grey lighten-2';
      }
    } else {
      return 'grey lighten-2';
    }
  }

  get isEcobonusCheckDone() {
    if (!this.selectedLead) return false;

    return this.selectedLead.ecCompletedAt !== null;
  }

  get ecobonusCheckResult() {
    if (!this.selectedLead || !this.selectedLead.ecResult) return null;

    return JSON.parse(this.selectedLead.ecResult);
  }
}
